var _rect, _rect2, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadImageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 91,
    viewBox: "0 0 164 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 91,
    rx: 4,
    fill: "#F4F5F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4.5,
    width: 151,
    height: 82,
    rx: 2.5,
    fill: "white",
    stroke: "#DADBDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 52.8729C51.1331 52.8729 55.2357 57.2823 59.1412 61.9155C59.3842 62.2038 59.6266 62.4931 59.8686 62.7819C61.5471 64.785 63.2106 66.7704 64.9819 68.3096C67.0177 70.0788 69.2554 71.3136 71.9091 71.3136C73.3385 71.3136 74.888 70.448 76.485 69.0979C78.1005 67.7323 79.8501 65.7964 81.6886 63.4988C84.934 59.4432 88.5054 54.1976 92.1576 48.8335C92.6435 48.1198 93.1308 47.404 93.619 46.6886C97.7855 40.5833 102.016 34.5061 105.984 29.9558C107.968 27.6806 109.872 25.8047 111.655 24.5011C113.447 23.1915 115.061 22.5 116.477 22.5C117.854 22.5 119.529 23.3887 121.45 25.1213C123.352 26.8367 125.412 29.3041 127.55 32.291C131.824 38.262 136.358 46.2372 140.509 54.2304C144.659 62.2199 148.416 70.2114 151.137 76.2066C152.498 79.2039 153.598 81.7015 154.359 83.4495C154.739 84.3235 155.034 85.01 155.235 85.4779C155.238 85.4853 155.241 85.4927 155.244 85.5H8.98591C9.12317 85.3143 9.28357 85.0983 9.4658 84.8543C10.1508 83.9375 11.1441 82.627 12.3763 81.0541C14.841 77.9077 18.2587 73.7144 22.0735 69.523C25.8905 65.329 30.0937 61.1495 34.1292 58.0223C36.1468 56.4589 38.1119 55.1668 39.9571 54.2672C41.8061 53.3658 43.5056 52.8729 45 52.8729Z",
    fill: "#F4F5F7",
    stroke: "#DADBDD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    transform: "matrix(-1 0 0 1 75 21)",
    fill: "#F4F5F7",
    stroke: "#DADBDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImageIcon);
export default __webpack_public_path__ + "static/media/upload-image-icon.1403ebc74ffb032086630749e4e4de0d.svg";
export { ForwardRef as ReactComponent };